import { RestResourcesOptions } from '../type'

export const mstResources: RestResourcesOptions = {
  provinces: {
    path: 'mst/provinces',
  },
  districts: {
    path: 'districts',
  },
  subdistricts: {
    path: 'subdistricts',
  },
  'special-flags': {
    path: '/products/special-flags',
  },
  'tire-characters': {
    path: '/products/tire-characters',
  },
  'mst-news': {
    path: '/news',
  },
  'mst-blog': {
    path: '/blogs',
  },
}
